const DAY = 24 * 60 * 60 * 1000;

/** Сколько осталось до срока решения: дата создания + decision_days. */
export function formatDecisionDays(createdAt: string, decisionDays: number | null): string {
    if (!decisionDays) return '—';

    const deadline = new Date(createdAt).getTime() + decisionDays * DAY;
    const left = Math.ceil((deadline - Date.now()) / DAY);

    if (left < 0) return `Просрочено на ${Math.abs(left)} дн.`;
    if (left === 0) return 'Сегодня';
    return `${left} дн.`;
}

export function formatDate(value: string): string {
    return new Intl.DateTimeFormat('ru-RU').format(new Date(value));
}